import { useInstancesByClassName } from 'hive-react-utils';
export function useCareLocations() {
    return useInstancesByClassName('ecarepd', 'careLocation');
}
